export const SUPPORT_EMAIL = 'raas-client-support@thredup.com';

// Fallback "book a call" link, used when the global-settings API has no value.
// Lives in shared/ (not a page module) so shared code — e.g. useGlobalSettings —
// can depend on it without reaching into @pages/*. Public pages re-export it
// from @pages/public/constants.
export const BOOK_A_CALL_HREF =
  'https://meetings.hubspot.com/emily-schmitz1/raas-team';
